import { omitBy, without } from "lodash";
import { Button } from "PFComponents/button";
import AutoSelect from "PFComponents/select/autoselect";
import { fetchAutocompleteSkills } from "PFCore/services/autocomplete/fetch_autocomplete_custom_values";
import DevSkillsIcon from "PFIcons/dev_skills.svg";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import css from "./develop_skills.module.scss";

export const DevelopSkills = ({ handleSubmit, handleDismiss, style, developmentalSkillsList }) => {
  const [values, setValues] = useState(
    developmentalSkillsList.map((item) => ({
      ...item,
      id: item.id,
      text: item.text,
      displayElement: <div>{item.text}</div>
    }))
  );
  const [submitValues, setSubmitValues] = useState([]);
  const [submited, setSubmited] = useState(false);

  const [selectedIds, setSelectedIds] = useState(values.map((value) => value.id));

  useEffect(() => {
    setSelectedIds(values.map((value) => value.id));
  }, [values]);

  return (
    <div className={css.wrapper} style={style}>
      <div className={css.header}>
        <DevSkillsIcon />
        <div className={css.headerText}>{submited ? "Thanks!" : "Develop your Skills!"}</div>
      </div>
      <div className={css.description}>
        {submited ? (
          <>
            <div>{"You've let us know what you want to develop."}</div>
            <div>
              {"Remember, you can always edit and rank these on your profile "}
              <Link to="/profiles/me/skills">here.</Link>
            </div>
          </>
        ) : (
          "We would like to help you hone three of the skills you most want to develop."
        )}
      </div>
      {!submited && (
        <div className={css.autoselect}>
          <AutoSelect
            label="Skills"
            placeholder={"Select 3..."}
            values={values}
            letCreate={false}
            cache={false}
            kind="white"
            alwaysEmpty
            closeOnChange
            rootClassName={css.inputAlign}
            query={(term) => fetchAutocompleteSkills({ term, global: false })}
            filterOptions={(res) => res.filter((item) => !selectedIds.includes(item.id))}
            formatOption={(item) => ({
              id: item.id,
              text: item.text,
              displayElement: <div>{item.text}</div>,
              item: {
                ...item,
                displayElement: <div>{item.text}</div>,
                text: item.text
              }
            })}
            handleChange={(skills) => {
              if (values.length >= 3) {
                return;
              }
              setValues([...values, { ...skills[0], developmental: true }]);
              setSubmitValues([...submitValues, { ...skills[0], developmental: true }]);
            }}
            handleRemove={setValues}
          />
        </div>
      )}
      {values.length > 0 && !submited && (
        <ul className={css.list}>
          {values.map((item) => (
            <React.Fragment key={item.id}>
              <li className={css.values}>
                {item.displayElement}
                <Button
                  rootClassName={css.remove}
                  kind="blank"
                  onClick={() => {
                    const filteredVAlues = without(values, item);
                    setValues(filteredVAlues);
                    setSubmitValues([...filteredVAlues, { ...item, developmental: false }]);
                  }}
                >
                  &times;
                </Button>
              </li>
            </React.Fragment>
          ))}
        </ul>
      )}
      <div className={css.buttonWrap}>
        {values.length > 0 && !submited && (
          <Button
            kind="primary"
            small
            onClick={() => {
              setSubmited(true);
              const formattedSkills = submitValues.map((skills) => omitBy(skills, "displayElement"));
              handleSubmit(formattedSkills);
            }}
          >
            Done
          </Button>
        )}
        {submited && (
          <Button kind="primary" small onClick={() => handleDismiss(true)}>
            Dismiss
          </Button>
        )}
      </div>
    </div>
  );
};

DevelopSkills.propTypes = {
  handleSubmit: PropTypes.func,
  handleDismiss: PropTypes.func,
  style: PropTypes.object,
  developmentalSkillsList: PropTypes.array
};

DevelopSkills.defaultProps = {
  developmentalSkillsList: []
};
